import { useState, useEffect, useRef } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";
import {
  getRegistroTelefonico,
  createRegistroTelefonico,
  updateRegistroTelefonico,
  deleteRegistroTelefonico,
} from "../functions/Soporte";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Anadir from "../../assets/img/svg/anadir.svg";
import CustomButton from "../../ui/button/Button";
import EditarA from "../../assets/img/svg/users/editar.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import { Snackbar, ClickAwayListener, Popper } from "@mui/material";
import LoaderDialog from "../../ui/loader/Loader";
import { headCellCenterAlign } from "../../utils/columnStyles";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import NuevoTelefonoModal from "./modals/NuevoTelefonoModal";

const TelefonosDeContacto = ({ API_URL, user }) => {
  const showDialog = useConfirmDialog();

  const [tableInstance, setTableInstance] = useState(null);
  const [data, setData] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const [openNuevoTelefono, setOpenNuevoTelefono] = useState(false);
  const [selectedTelefono, setSelectedTelefono] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const telefonos = await getRegistroTelefonico(API_URL);
        setData(telefonos);
      } catch (error) {
      } finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, []);

  const handleConfirmNuevoTelefono = async (telefonoForm) => {
    try {
      setShowLoader(true);
      if (telefonoForm.id) {
        await updateRegistroTelefonico(API_URL, telefonoForm);
        setShowSnackbar(true);
        setSnackbarMessage("Registro telefónico actualizado correctamente.");
      } else {
        await createRegistroTelefonico(API_URL, telefonoForm);
        setShowSnackbar(true);
        setSnackbarMessage("Registro telefónico creado correctamente.");
      }
      const telefonos = await getRegistroTelefonico(API_URL);
      setData(telefonos);
      setShowSnackbar(true);
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarMessage(
        "Ocurrió un error al guardar el registro telefónico. Inténtalo de nuevo."
      );
    } finally {
      setShowLoader(false);
      setOpenNuevoTelefono(false);
      setSelectedTelefono(null);
    }
  };

  const columns = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
    },
    {
      accessorKey: "numeroTelefonico",
      header: "Número telefónico",
    },
    {
      accessorKey: "correoElectronico",
      header: "Correo",
    },
    {
      accessorKey: "tipoNumeroTelefonico.name",
      header: "Tipo",
      accessorFn: (row) => {
        const tipo = row.tipoNumeroTelefonico?.name || "";
        return tipo.charAt(0).toUpperCase() + tipo.slice(1).toLowerCase();
      },
    },
    {
      id: "submenu",
      header: " ",
      size: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        const rowData = row.original;
        const anchorRef = useRef(null);
        const isOpen = openMenuIndex === row.index;

        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={anchorRef}
              onClick={() =>
                setOpenMenuIndex((prevIndex) =>
                  prevIndex === row.index ? null : row.index
                )
              }
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <Popper
              open={isOpen}
              anchorEl={anchorRef.current}
              placement="bottom-start"
              style={{ zIndex: 9999 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    marginTop: "5px",
                    padding: "5px",
                    minWidth: "80px",
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setSelectedTelefono(row.original);
                      setOpenNuevoTelefono(true);
                      setOpenMenuIndex(null);
                    }}
                  >
                    <img
                      src={EditarA}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Editar
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setOpenMenuIndex(null);
                      showDialog({
                        icon: "warning",
                        html: "¿Estas seguro de eliminar el registro telefónico?",
                        confirmButtonText: "Eliminar",
                        mostrarCancelar: true,
                        onConfirm: async () => {
                          try {
                            setShowLoader(true);
                            await deleteRegistroTelefonico(API_URL, rowData.id);
                            const telefonos = await getRegistroTelefonico(
                              API_URL
                            );
                            setData(telefonos);
                            setShowSnackbar(true);
                            setSnackbarMessage(
                              "Registro telefónico eliminado correctamente."
                            );
                          } catch (error) {
                            setShowSnackbar(true);
                            setSnackbarMessage(
                              "Ocurrió un error al eliminar el registro telefónico. Inténtalo de nuevo."
                            );
                          } finally {
                            setShowLoader(false);
                          }
                        },
                      });
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Eliminar
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    columns,
    data,
    enableSorting: true,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
  });

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} />
      </div>
      <LoaderDialog open={showLoader} />

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />

      <NuevoTelefonoModal
        open={openNuevoTelefono}
        onClose={() => {
          setOpenNuevoTelefono(false);
          setSelectedTelefono(null);
        }}
        onConfirm={handleConfirmNuevoTelefono}
        telefono={selectedTelefono}
        API_URL={API_URL}
      />

      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
        }}
      >
        <div
          className="pgp-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <h1 className="map-title" style={{ margin: 0 }}>
            Teléfonos de contacto
          </h1>
          {user?.perfil?.esAdministrador && (
            <CustomButton
              background="#223D51"
              width="155px"
              height="31px"
              fontSize="14px"
              color="#FFFFFF"
              text="Agregar teléfono"
              fontWeight={700}
              fontStyle="normal"
              border={0}
              icon={true}
              src={Anadir}
              iconW="12px"
              iconM="5px"
              onClick={() => {
                setOpenNuevoTelefono(true);
                setSelectedTelefono(null);
              }}
            />
          )}
        </div>

        <div>
          <MaterialReactTable
            table={table}
            onTableReady={(table) => setTableInstance(table)}
          />
        </div>
      </div>
    </div>
  );
};

export default TelefonosDeContacto;
